import { KonvaEventObject } from 'konva/lib/Node';
import { memo } from 'react';
import { Rect } from 'react-konva';
import { Point } from './types';
import { POLYGON_LINE_STROKE_COLOR } from './utils';

const VERTEX_HANDLE_SIZE = 9;
const HANDLE_FILL = '#ffffff';

interface Props {
  point: Point;
  index: number;
  onDragStart: (e: KonvaEventObject<DragEvent>) => void;
  onDragMove: (e: KonvaEventObject<DragEvent>) => void;
  onDragEnd: (e: KonvaEventObject<DragEvent>) => void;
  onDoubleClick: (e: KonvaEventObject<MouseEvent>) => void;
  onMouseEnter: (e: KonvaEventObject<MouseEvent>) => void;
  onMouseLeave: (e: KonvaEventObject<MouseEvent>) => void;
}

export const VertexHandle = memo(function VertexHandle({
  point,
  index,
  onDragStart,
  onDragMove,
  onDragEnd,
  onDoubleClick,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  return (
    <Rect
      x={point.x - VERTEX_HANDLE_SIZE / 2}
      y={point.y - VERTEX_HANDLE_SIZE / 2}
      width={VERTEX_HANDLE_SIZE}
      height={VERTEX_HANDLE_SIZE}
      fill={HANDLE_FILL}
      stroke={POLYGON_LINE_STROKE_COLOR}
      strokeWidth={1}
      draggable
      data-index={index}
      onDragStart={onDragStart}
      onDragMove={onDragMove}
      onDragEnd={onDragEnd}
      onDblClick={onDoubleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
});

export const VERTEX_SIZE = VERTEX_HANDLE_SIZE;
